import { Patch } from "services/apiService";
import {
  PO_AMEND_PATCH_REQUEST,
  PO_AMEND_PATCH_SUCCESS,
  PO_AMEND_PATCH_ERROR,
} from "./action-type";
import { AMEND_PURCHASE_ORDER_ENDPOINT, BASE_URL, SOMS_API_KEY } from "services/CONSTANTS";

export const amendPoPatch = (params, poNo) => async (dispatch) => {
  const apiUrl = `${BASE_URL}${AMEND_PURCHASE_ORDER_ENDPOINT}/${poNo}?apikey=${SOMS_API_KEY}`;
  dispatch({ type: PO_AMEND_PATCH_REQUEST });

  Patch({
    url: apiUrl,
    params: params,
    config: {},
  })
    .then((response) => {
      if (response.status === 200) {
        dispatch({
          type: PO_AMEND_PATCH_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: PO_AMEND_PATCH_ERROR,
          payload: {
            ...response,
            extOrderId: response.data.extOrderId? response.data.extOrderId : poNo
          },
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: PO_AMEND_PATCH_ERROR,
        payload: {
          ...err.response, 
          extOrderId: err.response.data.extOrderId? err.response.data.extOrderId : poNo
        },
      });
    });
};
